import { createAuth } from "./createAuth";
import dotenv from "dotenv";

dotenv.config();

export function forgotPass() {
  const authorization = document.querySelector(".authorization");
  const forgotForm = document.createElement("form");
  forgotForm.id = "authForm";
  forgotForm.classList = "forgotForm";
  authorization.appendChild(forgotForm);

  const blank = document.createElement("div");
  blank.classList = "auth__background";
  forgotForm.appendChild(blank);

  const formTitle = document.createElement("h1");
  formTitle.textContent = "atkūrimas";
  formTitle.textContent = formTitle.textContent.toUpperCase();
  formTitle.classList = "auth__title";
  blank.appendChild(formTitle);

  const emailLabel = document.createElement("label");
  emailLabel.classList = "recovery_email";
  emailLabel.textContent = "el. paštas:";
  emailLabel.textContent = emailLabel.textContent.toUpperCase();
  forgotForm.appendChild(emailLabel);

  const emailInput = document.createElement("input");
  emailInput.type = "email";
  emailInput.name = "email";
  emailInput.id = "email";
  emailInput.required = true;
  forgotForm.appendChild(emailInput);

  const allerts = document.createElement("div");
  allerts.id = "allerts";
  allerts.classList = "forgotAllert";
  allerts.style.height = "50px";
  forgotForm.appendChild(allerts);

  const backButton = document.createElement("button");
  backButton.textContent = "Grįžti atgal";
  backButton.textContent = backButton.textContent.toUpperCase();
  backButton.id = "back";
  backButton.setAttribute("type", "button");
  forgotForm.appendChild(backButton);

  const submitButton = document.createElement("button");
  submitButton.textContent = "Atnaujinti";
  submitButton.textContent = submitButton.textContent.toUpperCase();
  forgotForm.appendChild(submitButton);

  backButton.addEventListener("click", () => {
    authorization.remove();
    createAuth();
  });

  // Password reset method
  const app = new Realm.App({ id: `${process.env.REALM_WEB_ID}` });
  submitButton.addEventListener("click", async (event) => {
    event.preventDefault();
    submitButton.textContent = "Kraunasi...";
    submitButton.disabled = true;

    const email = {
      email: emailInput.value,
    };

    try {
      await app.emailPasswordAuth.sendResetPasswordEmail(email);
      setSuccess("Slaptažodžio atkūrimo nuoroda išsiųsta nurodytu el. paštu!");
      submitButton.textContent = "Pateikti";
      submitButton.textContent = submitButton.textContent.toUpperCase();
      submitButton.disabled = false;
    } catch (error) {
      setError("email", "Neteisingas el. paštas arba nesate užsiregistravę.");
      submitButton.textContent = "Pateikti";
      submitButton.textContent = submitButton.textContent.toUpperCase();
      submitButton.disabled = false;
    }
  });
}

function setError(inputName, errorMessage) {
  clearErrors();
  const input = document.getElementById(inputName);
  input.classList.add("error");
  const error = document.getElementById("allerts");
  error.classList.add("errorAllerts");
  error.textContent = errorMessage;
}

function setSuccess(message) {
  clearErrors();
  const success = document.getElementById("allerts");
  success.classList.add("successAllerts");
  success.textContent = message;
}

function clearErrors() {
  const inputs = document.querySelectorAll("input");
  inputs.forEach((input) => {
    input.classList.remove("error");
  });

  const error = document.getElementById("allerts");
  error.removeAttribute("class");
  error.textContent = "";
}
